import * as yup from "yup";

export const validationSchema = yup.object({
  addressAttributes: yup.object({
    fullAddress: yup.lazy((value) => {
      if (typeof value === "object" && value !== null) {
        return yup
          .object({
            countryCode: yup
              .string()
              .oneOf(["US"], "Only addresses in the United States are allowed.")
              .required(),
          })
          .required("Location is required.");
      }

      return yup
        .string()
        .required("Location is required.")
        .test(
          "is-us-address",
          "Only addresses in the United States are allowed.",
          (val) =>
            !!val &&
            /(USA|United States|US)$/i.test(val.trim())
        );
    }),
  }),
});
